import { Button } from "primereact/button";
import { rowColumn } from "../../components/table/Table";
import React from "react";
import useApiClient from "../customHooks/hooks/useApiClient";
import { fileData } from "../../components/form/components/FileUploadComponent";
import { formatBits } from "../CommonFunctions";

export const referenceDataManagementTable: rowColumn[] = [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "File name and type",
    column: "fileName",
    type: "string",
    allowSort: true,
    sortOn: "FileName",
  },
  {
    label: "File Size",
    column: "size",
    type: "number",
    allowSort: true,
    sortOn: "Size",
    body: (rowData) => formatBits(rowData.size),
  },
  {
    label: "Email of submitting user",
    column: "emailCreated",
    type: "string",
    allowSort: true,
    sortOn: "EmailCreated",
  },
  {
    label: "Date and time stamp of the file upload",
    column: "uploadDate",
    type: "dateTime",
    allowSort: true,
    sortOn: "UploadDate",
  },
  {
    label: "Download",
    body(rowData) {
      const { fetchData } = useApiClient("fileHandler");
      const downloadFile = (file: fileData) => {
        fetchData("read", { filename: file.blobKey, container: "referencedata" }).then(({ data }) => {
          const { url } = data;
          window.open(url, "_blank");
        });
      };

      return <Button label="Download" type="button" className="link mr-5" onClick={() => downloadFile(rowData)} icon="pi pi-download" />;
    },
  },
];
